import type { ReactNode } from 'react';

export const symbol_usb: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M428-100q-20-20-20-52 0-22 11-40t31-29v-111H302q-24 0-42-18t-18-42v-109q-20-9-31-26.5T200-568q0-32 20-52t52-20q32 0 52 20t20 52q0 23-11 40.5T302-501v109h148v-340h-50q-9 0-13-8t1-16l80-109q5-6 12-6t12 6l80 109q5 8 1 16t-13 8h-50v340h148v-104h-27q-6 0-10.5-4.5T616-511v-114q0-6 4.5-10.5T631-640h114q6 0 10.5 4.5T760-625v114q0 6-4.5 10.5T745-496h-27v104q0 24-18 42t-42 18H510v111q20 11 31 30t11 39q0 32-20 52t-52 20q-32 0-52-20Z"
		/>
	</svg>
);
